import { Component } from '@angular/core';

@Component({
    selector: 'app-sobre-metodologia',
    templateUrl: './metodologia.component.html',
    styleUrls: ['./metodologia.component.css']
})

export class Sobre_MetodologiaComponent {
}
